import { Bounds, namespace, Point } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractItem from './abstractItem';

namespace('Ofcs.Editor.Item');

/**
 * @class InsertItem
 * @extends AbstractItem
 */
export default window.Ofcs.Editor.Item.InsertItem = AbstractItem.extend({

    type: 'insert',

    supportsGrids: true,

    supportsDepth: false,

    defaults: {
        /**
         * @property {string} Type
         */
        type: null,

        /**
         * Current position
         * @property {Point} attributes.position
         */
        position: new Point(0, 0),

        /**
         * Number of rows
         * @property {number} attributes.rows
         */
        rows: 0,

        /**
         * Number of columns
         * @property {number} attributes.columns
         */
        columns: 0,

        /**
         * @type {number}
         */
        depth: 0,
    },

    /**
     * Returns a new bounding box based on the current *attributes* of the item
     *
     * @return {Bounds} Bounding box of the item
     */
    getBounds() {
        return new Bounds(
            this.get('position').clone(),
            new Point(this.get('position').x + this.get('width'), this.get('position').y + this.get('height')),
        );
    },

    /**
     * Returns a new bounding box based on the current *attributes* of the item
     *
     * @return {Bounds} Bounding box of the item
     */
    getMarginBounds() {
        return this.getBounds();
    },

    /**
     * Return safety margin for this item
     *
     * @return {number}
     */
    getSafetyMargin() {
        return 0;
    },

    /**
     * @return {Array}
     */
    getLines() {
        return [];
    },

    /**
     * Returns a new bounding box based on the current *attributes* of the item
     *
     * @return {Bounds} Bounding box of the item
     */
    getInnerBounds() {
        return this.getBounds();
    },
    /**
     * Translate object into json stringable types. This method will be used
     * by JSON.stringify() automaticly.
     *
     * @return {Object}
     */
    toJSON(...args) {
        const attributes = AbstractItem.prototype.toJSON.apply(this, args);
        return {
            itemId: attributes.itemId,
            type: attributes.type,
            x: attributes.x,
            y: attributes.y,
            depth: attributes.depth,
        };
    },

});
